export enum ChannelAnalogInputUseMode {
	MicIn = 'MIC_IN',
	AcousticEchoCancellation = 'ACOUSTIC_ECHO_CANCELLATION'
}
